import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { LeadsActions } from ".";
import { initialLead, initialLeadState } from "./leads.types";
import {
	CLEAR_LEAD,
	CLEAR_LEAD_STATE,
	FETCH_LEADS_LIST_FAILED,
	FETCH_LEADS_LIST_PROGRESS,
	FETCH_LEADS_LIST_STATUS_COUNT_FAILED,
	FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS,
	FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS,
	FETCH_LEADS_LIST_SUCCESS,
	FETCH_LEAD_FAILED,
	FETCH_LEAD_PROGRESS,
	FETCH_LEAD_STATUS_COUNT_FAILED,
	FETCH_LEAD_STATUS_COUNT_PROGRESS,
	FETCH_LEAD_STATUS_COUNT_SUCCESS,
	FETCH_LEAD_SUCCESS,
	FETCH_FOLLOW_UP_HISTORY_PROGRESS,
	FETCH_FOLLOW_UP_HISTORY_SUCCESS,
	FETCH_FOLLOW_UP_HISTORY_FAILED,
	FETCH_LEADS_BY_COMPANY_PROGRESS,
	FETCH_LEADS_BY_COMPANY_SUCCESS,
	FETCH_LEADS_BY_COMPANY_FAILED,
} from "./leadsActions";

export const leadsReducer = (
	state: IStoreState["leads"] = initialLeadState,
	action: LeadsActions
) => {
	switch (action.type) {
		case FETCH_LEADS_LIST_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.InProgress;
				draftState.list.list = [];
				draftState.list.totalRecords = 0;
			});
			return newState;
		}
		case FETCH_LEADS_LIST_SUCCESS: {
			const { list, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.list = list;
				draftState.list.totalRecords = totalRecords;
			});
			return newState;
		}
		case FETCH_LEADS_LIST_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Failed;
				draftState.list.list = [];
				draftState.list.totalRecords = 0;
			});
			return newState;
		}
		case FETCH_LEAD_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.lead.loading = LoadState.InProgress;
				draftState.lead.data = initialLead;
			});
			return newState;
		}
		case FETCH_LEAD_SUCCESS: {
			const { lead } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.lead.loading = LoadState.Loaded;
				draftState.lead.data = lead;
			});
			return newState;
		}
		case FETCH_LEAD_FAILED: {
			const { errorMessage } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.lead.loading = LoadState.Failed;
				draftState.lead.error = errorMessage;
			});
			return newState;
		}
		case CLEAR_LEAD: {
			const newState = produce(state, (draftState) => {
				draftState.lead.loading = LoadState.NotLoaded;
				draftState.lead.data = initialLead;
			});
			return newState;
		}

		case FETCH_LEAD_STATUS_COUNT_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.recordCounts.loading = LoadState.InProgress;
				draftState.recordCounts.list = [];
			});
			return newState;
		}
		case FETCH_LEAD_STATUS_COUNT_SUCCESS: {
			const { data } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.recordCounts.loading = LoadState.Loaded;
				draftState.recordCounts.list = data;
			});
			return newState;
		}
		case FETCH_LEAD_STATUS_COUNT_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.recordCounts.loading = LoadState.Failed;
				draftState.recordCounts.list = [];
			});
			return newState;
		}

		case FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.InProgress;
				draftState.list.list = [];
				draftState.list.totalRecords = 0;
			});
			return newState;
		}
		case FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS: {
			const { list, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.list = list;
				draftState.list.totalRecords = totalRecords;
			});
			return newState;
		}
		case FETCH_LEADS_LIST_STATUS_COUNT_FAILED: {
			const newState = produce(state, (draftState) => {
				draftState.list.loading = LoadState.Failed;
				draftState.list.list = [];
				draftState.list.totalRecords = 0;
			});
			return newState;
		}

		case FETCH_FOLLOW_UP_HISTORY_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.followUpHistory.loading = LoadState.InProgress;
				draftState.followUpHistory.list = [];
				draftState.followUpHistory.error = null;
			});
			return newState;
		}
		case FETCH_FOLLOW_UP_HISTORY_SUCCESS: {
			const { list } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.followUpHistory.loading = LoadState.Loaded;
				draftState.followUpHistory.list = list;
				draftState.followUpHistory.error = null;
			});
			return newState;
		}
		case FETCH_FOLLOW_UP_HISTORY_FAILED: {
			const { errorMessage } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.followUpHistory.loading = LoadState.Failed;
				draftState.followUpHistory.list = [];
				draftState.followUpHistory.error = errorMessage;
			});
			return newState;
		}

		case FETCH_LEADS_BY_COMPANY_PROGRESS: {
			const newState = produce(state, (draftState) => {
				draftState.companyLeads.loading = LoadState.InProgress;
				draftState.companyLeads.list = [];
				draftState.companyLeads.totalRecords = 0;
				draftState.companyLeads.error = null;
			});
			return newState;
		}
		case FETCH_LEADS_BY_COMPANY_SUCCESS: {
			const { list, totalRecords } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.companyLeads.loading = LoadState.Loaded;
				draftState.companyLeads.list = list;
				draftState.companyLeads.totalRecords = totalRecords;
				draftState.companyLeads.error = null;
			});
			return newState;
		}
		case FETCH_LEADS_BY_COMPANY_FAILED: {
			const { errorMessage } = action.payload;
			const newState = produce(state, (draftState) => {
				draftState.companyLeads.loading = LoadState.Failed;
				draftState.companyLeads.list = [];
				draftState.companyLeads.error = errorMessage;
			});
			return newState;
		}

		case CLEAR_LEAD_STATE: {
			return initialLeadState;
		}
		default: {
			return state;
		}
	}
};
